import { makeStyles } from "@mui/styles";
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useFinalScore = makeStyles(() => ({
    container: {
      width: "75%",
      margin: "3rem auto",
      textAlign: "center",
      "& .MuiTypography-caption": {
        fontFamily: "Jost",
        fontSize: "1.2rem",
        fontWeight: "500",
        color: "#223852",
      },
      "& .MuiTypography-h6": {
        fontFamily: "Jost",
        fontSize: "1.5rem",
        fontWeight: "700",
        color: "#223852",
      },
      [theme.breakpoints.down("xs")]: {
        margin: "3rem auto 0rem",
      },
    },
    yourScore: {
      margin: "2rem auto",
      background: "#E7E7E799",
      width: "15%",
      padding: "0.3rem 2rem",
      borderRadius: "6px",
      [theme.breakpoints.down("xs")]: {
        width: "50%",
        margin: "2rem auto 1rem",
      },
    },
    incorrectCorrectTime: {
      display: "flex",
      justifyContent: "center",
      margin: "2rem 0",
      [theme.breakpoints.down("xs")]: {
        margin: "0",
        flexWrap: 'wrap',
      },
    },
    divider: {
      margin: "0 3rem",
      [theme.breakpoints.down("xs")]: {
        margin: "0 1rem",
      },
    },
    dividerlst: {
      margin: "0 3rem",
      [theme.breakpoints.down("xs")]: {
        display: "none"
      },
    },
    timetakencont: {
      [theme.breakpoints.down("xs")]: {
        marginTop:'1rem',
      },
    },
  }));

export default useFinalScore;
